module.exports = __webpack_public_path__ + "img/tableFlower_04.16e1eba3.jpg";